export default "__VITE_ASSET__FpDMbQLB__"